(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('Company', Company);

    Company.$inject = ['$resource', 'ENV'];

    function Company($resource, ENV) {
        var resourceUrl = ENV.API_BASE_URL + 'api/companies/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();
